module.exports = __webpack_public_path__ + "assets/img/head_logo.3c96cba5.png";